export function agency(state = {}, action) {
  const foundIndex = state?.agents?.findIndex(
    agent => agent.id === action?.res?.data?.id,
  );

  const getUpdatedAgentsArray = (agents, updatedAgent) =>
    agents.map(agent => (agent.id === updatedAgent.id ? updatedAgent : agent));

  const getAgencyCarriersList = carriers =>
    carriers.map(carrier => ({ label: carrier, value: carrier }));

  switch (action.type) {
    case 'GET_AGENCY_CARRIERS':
      return {
        ...state,
        agency_carriers: getAgencyCarriersList(action?.res?.data),
      };
    case 'SAVE_AGENCY':
      return { ...state, ...action.payload.agency };
    case 'SET_VALIDATION_ERRORS':
      return { ...state, errors: action.payload.errors };
    case 'ADD_NEW_AGENT':
      return { ...state, agents: [...state.agents, action.res.data] };
    case 'ADD_NEW_AGENT_FAILURE':
    case 'UPDATE_AGENT_FAILURE':
      return { ...state, errors: action?.error?.response?.data };
    case 'UPDATE_AGENT':
      state.agents[foundIndex] = action.res.data;
      return { ...state, agents: [...state.agents] };
    case 'CLEAR_AGENT_ERRORS':
      delete state.errors;
      return { ...state };
    case 'SAVE_UPDATED_AGENT':
      return {
        ...state,
        agents: getUpdatedAgentsArray(state.agents, action.payload.agent),
      };
    case 'SAVE_AGENT_DELETION':
      return {
        ...state,
      };
    default:
      return state;
  }
}
